<template>
  <div>
    <div class="container">

      <div class="page-title">
        {{ $t('loyalty.main_title') }}
      </div>

      <Tabs>
        <TabSection title="Configuration" v-if="$store.getters.loggedUserHasBranchAdmin" collapsible>
          <div class="columns">
            <div class="column">
              <div class="group" v-if="$store.getters.loggedUserHasSuperAdmin">
                <label>{{ $t('loyalty.type') }}</label>
                <select v-model="selected">
                  <option :value="null">{{ $t('loyalty.none') }}</option>
                  <option value="free_bees">Free Bees</option>
                  <option value="data_candy">DataCandy</option>
                </select>
              </div>
              <div class="fidelity-program" v-show="isFreeBeesSelected">
                <div class="group" v-show="selected !== null">
                  <input id="free_activated_chk" type="checkbox" v-model="free_bees.activated">
                  <label for="free_activated_chk">{{ $t('loyalty.activated') }}</label>
                </div>
              </div>
              <div class="fidelity-program" v-show="isDataCandySelected">
                <div class="group">
                  <label>Merchant ID (MID)</label>
                  <input type="text" v-model="data_candy.data.mid"
                    :class="{ invalid: $validate.error('data_candy.data.mid') }">
                </div>
                <div class="group">
                  <label>Merchant Password (MPW)</label>
                  <input type="text" v-model="data_candy.data.mpw"
                    :class="{ invalid: $validate.error('data_candy.data.mpw') }">
                </div>
                <div class="group">
                  <label>Access key</label>
                  <input type="text" v-model="data_candy.data.access_key"
                    :class="{ invalid: $validate.error('data_candy.data.access_key') }">
                </div>
                <div class="group">
                  <label>Impersonated Merchant ID (IMI)</label>
                  <input type="text" v-model="data_candy.data.imi"
                    :class="{ invalid: $validate.error('data_candy.data.imi') }">
                </div>
                <div class="group">
                  <input id="candy_activated_chk" type="checkbox" v-model="data_candy.activated">
                  <label for="candy_activated_chk">{{ $t('loyalty.activated') }}</label>
                </div>
              </div>
            </div>
            <div class="column">
              <template v-if="isFreeBeesSelected">
                <div class="group">
                  <label>Partner ID</label>
                  <input type="text" v-model="free_bees.data.partner_id">
                </div>
                <div class="group">
                  <label>Location ID</label>
                  <input type="text" v-model="free_bees.data.location_id">
                </div>
                <div class="group">
                  <label>Security Key</label>
                  <input type="text" v-model="free_bees.data.security_key">
                </div>
              </template>
            </div>
          </div>
          <div class="subtitle">{{ $t('settings.advanced_configurations') }}</div>
          <div class="columns">
            <div class="column">
              <div class="group">
                <input id="chkManualLoyaltyCards" type="checkbox" v-model="enableManualLoyaltyCards">
                <label for="chkManualLoyaltyCards">
                  {{ $t("loyalty.enable_manual_loyalty_cards") }}&nbsp;&nbsp;<Tooltip
                    :text="$t('loyalty.manual_loyalty_card_tooltip')"></Tooltip>
                </label>
              </div>
            </div>
          </div>
        </TabSection>
      </Tabs>

      <div class="actions">
        <button class="btn btn-primary" @click="save">{{ $t('save') }}</button>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import LocalizedInput from '@/components/tools/LocalizedInput.vue';

  export default {

    name: "CompanyLoyaltyConfig",

    components: { LocalizedInput },

    data() {
      return {
        companyId: undefined,
        branchId: undefined,
        selected: null,
        data_candy: {
          type: 'data_candy',
          activated: false,
          data: {
            mid: '',
            mpw: '',
            access_key: '',
            imi: '',
          }
        },
        free_bees: {
          type: 'free_bees',
          activated: false,
          data: {
            partner_id: '',
            location_id: '',
            security_key: ''
          }
        },
        enableManualLoyaltyCards: false
      }
    },

    validate: {
      "data_candy.data.mid": {
        required: true,
        condition: function () {
          return this.isDataCandySelected;
        }
      },
      "data_candy.data.mpw": {
        required: true,
        condition: function () {
          return this.isDataCandySelected;
        }
      },
      "data_candy.data.access_key": {
        required: true,
        condition: function () {
          return this.isDataCandySelected;
        }
      },
      "data_candy.data.imi": {
        required: true,
        condition: function () {
          return this.isDataCandySelected;
        }
      }
    },

    computed: {
      isFreeBeesSelected() {
        return this.selected === 'free_bees'
      },
      isDataCandySelected() {
        return this.selected === 'data_candy'
      },
    },

    async mounted() {
      this.companyId = this.$route.query.company;
      this.branchId = this.$route.query.branch;

      this.$store.state.pageTitleTranslationKey = "loyalty.title";
      this.$store.state.pageIcon = "/icon/loyalty.svg";

      showSpinner();
      let response = await this.getCompany({ branchId: this.branchId, companyId: this.companyId, augment: 'loyalty' });
      hideSpinner();
      if (response) {
        this.enableManualLoyaltyCards = response.enableManualLoyaltyCards;
        if (response.loyaltyConfig && response.loyaltyConfig.type) {
          this.selected = response.loyaltyConfig.type;
          Object.assign(this[response.loyaltyConfig.type], response.loyaltyConfig);
        }
      } else {
        toast(this.$t("error.no_server"), "error");
      }
    },

    methods: {
      ...mapActions(['getCompany', 'saveCompany']),

      async save() {
        if (!this.$validate.valid()) {
          toast(this.$t("branch.error.required"), "error", this.$t("error.title"));
          this.$validate.validateAllOnce();
          return;
        }

        let data = {
          loyaltyConfig: this.selected ? JSON.parse(JSON.stringify(this[this.selected])) : null,
          enableManualLoyaltyCards: this.enableManualLoyaltyCards
        };
        showSpinner();
        let response = await this.saveCompany({ branchId: this.branchId, companyId: this.companyId, augment: 'loyalty', data });
        hideSpinner();
        if (response) {
          toast(this.$t("company.success"), "success");
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .panel .subtitle {
    margin-top: 20px;
    text-transform: none;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(252, 102, 80, 0.55);
  }

  .desc {
    margin-bottom: 15px;
  }
</style>